import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-cancel-page">
            <div className="text-center max-w-md">
                <h1 className="font-serif text-4xl mb-4">Paiement annulé</h1>
                <p className="text-muted-foreground mb-8">Aucun montant n'a été prélevé. Vous pouvez réessayer quand vous le souhaitez.</p>
                <Link to="/abonnements">
                    <Button className="rounded-full h-12 px-6 bg-primary text-primary-foreground">Retour aux abonnements</Button>
                </Link>
            </div>
        </div>
    );
}
